import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import I18n from '../I18n';
import CustomLink from '../customLink';
import DownArrow from '../svgIcon/downArrow';
import gtagEvent from '../../utils/gtag';

/**
 * The title which comes along with a drop down menu in the header (desktop mode)
 * When the user hovers on the menu title, it will show a drop down menu which consists of a list of links
 */
const HoverDropDownMenu = ({ items, children, noArrow, menuLeft, ...rest }) => (
  <Box
    px="space.m"
    py="space.s"
    cursor="pointer"
    position="relative"
    _hover={{
      '> div': { pointerEvents: 'auto', opacity: 1 },
    }}
    onMouseEnter={() =>
      gtagEvent('bloctoweb_click_product', {
        location: 'header',
      })
    }
    role="group"
    {...rest}
  >
    <Box width="115px" height="5px" position="absolute" top="100%" />
    <Flex alignItems="center" transition="all 0.2s" _groupHover={{ color: 'font.highlight' }}>
      {children}
      {!noArrow && <DownArrow />}
    </Flex>
    <Box
      pointerEvents="none"
      opacity="0"
      position="absolute"
      top="calc(100% + 5px)"
      left={menuLeft}
      bg="rgba(255, 255, 255, 0.70)"
      borderRadius="20px"
      boxShadow="0px 1px 15px 0px rgba(0, 0, 0, 0.05)"
      backdropFilter="blur(20px)"
      transition="0.3s opacity"
      p="32px 24px"
    >
      {items.map((item) => (
        <CustomLink
          key={item.titleTranslationKey}
          display="grid"
          gridTemplateColumns="max-content 1fr"
          alignItems="center"
          whiteSpace="nowrap"
          px="space.l"
          py="space.s"
          borderRadius="100px"
          _hover={{
            background: 'rgba(249, 249, 249, 0.60)',
            boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
            color: item?.icon ? 'inherit' : 'font.highlight',
          }}
          to={item?.href}
          noHoverStyle
          isExternal={item.isExternal}
          gtag={item.gtag}
          onClick={item.onClick}
        >
          {!!item.icon && <Image src={item.icon} />}
          <Box flex="0 0 auto" ml="space.4xs" textAlign="left">
            <Text lineHeight="130%">
              <I18n id={item.titleTranslationKey} />
            </Text>

            {!!item?.descTranslationKey && (
              <Text fontSize="size.help.1" color="font.secondary" lineHeight="18px">
                <I18n id={item.descTranslationKey} />
              </Text>
            )}
          </Box>
        </CustomLink>
      ))}
    </Box>
  </Box>
);

HoverDropDownMenu.propTypes = {
  children: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      titleTranslationKey: PropTypes.string,
    })
  ).isRequired,
  noArrow: PropTypes.bool,
  fill: PropTypes.string,
  menuLeft: PropTypes.string,
  onClick: PropTypes.func,
};

HoverDropDownMenu.defaultProps = {
  children: null,
  fill: '#ffffff',
  noArrow: false,
  menuLeft: '1rem',
  onClick: null,
};

export default HoverDropDownMenu;
